import styled from 'styled-components'

export const EligibilityContainer = styled.div`
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  font-family: Arial;
  border-left: 2px solid ${props => props.status === 'MISSED' ? '#CACACA' : '#7B61FF'};
  border-top: 1px solid ${props => props.status === 'MISSED' ? '#CACACA' : '#7B61FF'};
  border-right: 1px solid ${props => props.status === 'MISSED' ? '#CACACA' : '#7B61FF'};
  border-bottom: 1px solid ${props => props.status === 'MISSED' ? '#CACACA' : '#7B61FF'};
`

export const EligibilitySection = styled.div`
  margin-bottom: 16px;
`

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #000;
  font-size: 12px;
  line-height: 20px;
`

export const CriteriaContainer = styled.div`
  display: flex;
  margin-bottom: 15px;
`

export const CriteriaContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const CriteriaLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #000;
  line-height: 14px;
  margin-bottom: 5px;
`

export const CriteriaValue = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #000;
`

export const IconWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  height: 100%;
  align-self: flex-start;
`

export const Avatar = styled.div`
  width: 50px;
  height: 50px;
  background-color: #F5A623;
  color: white;
  font-weight: bold;
  font-size: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
`